DJ.addBehavior('js-faq-toggle', '.faq-block_question', {
  attach: function (context, settings, behavior) {

    const handleToggle = function (i){
      const faqList = i.parents('.faq-block_list');
      const items = faqList.find('.faq-block_item');
      faqList.find('.faq-block_answer-container').empty();
      const currentItem = i.parent();
      items.not(currentItem).removeClass('opened');
      items.not(currentItem).find('.faq-block_question').attr('aria-expanded', 'false');
      const answerContainer = currentItem.nextAll('.faq-block_answer-container:first');

      if (currentItem.hasClass('opened')) {
        currentItem.removeClass('opened');
        i.attr('aria-expanded', 'false');
      } else {
        i.next().clone().appendTo(answerContainer);
        currentItem.addClass('opened');
        i.attr('aria-expanded', 'true');
      }
    }

    jQuery(this).on('click', function () {
      handleToggle(jQuery(this))
    });

    jQuery(this).on('keydown', function( event ) {
      if ( event.key === 'Enter' || event.key === ' ' ) {
        event.preventDefault();
        handleToggle(jQuery(this))
      }
    });

    jQuery(document).on('click', '.faq-block_close', function (e) {
      jQuery(this).parents('.faq-block_list').find('.faq-block_item').removeClass('opened');
      jQuery(this).parents('.faq-block_answer-container').empty();
    });
  },

  detach: function (context, settings) {}
});
